import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUrlParam } from './utils/common';
import { decodeMParam } from './utils/jwtUtils';
import './App.scss';
import Header from './containers/Header/Header';
import Frame from './containers/Frame/Frame';
import FrameAuto from './containers/FrameAuto/FrameAuto';
import NotFound from './containers/NotFound/NotFound';
import AutoSignIn from './containers/AutoSignIn/AutoSignIn';
import Call from './containers/Call/Call';
import { setPage } from './redux/actions/commonActions';
import store from "./redux/store";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

function App({ showHeader }) {
    const { common, ui } = useSelector(state => state);
    const [isVisible, setIsVisible] = useState(true);
    const location = useLocation(); // Get current location
    let pageClass = common?.common?.page ? common?.common?.page : 'chat';  // Default class (for other pages)
    
    // Get and decode the m parameter
    const encryptedMParam = getUrlParam('m');
    let mParam = null;
    let mUsername = null;
    let mEmail = null;
    let mReferer = null;
    
    // Only try to decode if m parameter exists
    if (encryptedMParam) {
        try {
            const decodedData = decodeMParam(encryptedMParam);
            if (decodedData) {
                mParam = decodedData.msg || null;
                mUsername = decodedData.username || null;
                mEmail = decodedData.email || null;
                mReferer = decodedData.referer || null;
            }
        } catch (error) {
            console.error('Error processing m parameter:', error);
        }
    }
    
    // Determine if this is a proactive chat
    const isProactive = (getUrlParam('proactive') == 1) ? true : false;
    const isFlutter = (getUrlParam('app') == 'flutter') ? true : false;
    // const isPlaytech = (config?.appApp && config?.appApp.playtech) ? true : false;

    // Detect Android device
    useEffect(() => {
        const isAndroid = /Android/i.test(navigator.userAgent);
        if (isAndroid) {
            document.body.classList.add('android-device');
        }
    }, []);

    // Determine page class based on route
    if (location.pathname.startsWith('/call')) {
        pageClass = 'call';
    } else if (location.pathname === '*') {
        pageClass = 'not-found';
    }

    return (
        <div className={`app-wrapper ${pageClass}`} style={{ height: '100vh' }}>
            <div className='app-container'>
                {showHeader && <Header />} {/* Conditionally render Header based on prop */}
                <div className={'app-wrapper-inner'} style={{ height: '100%' }}>
                    <Routes>
                        <Route path='/call/:brand' element={<Call />} />
                        <Route path='/:language/:brand' element={ (isProactive) ? <FrameAuto /> : <Frame/> } />
                        <Route path="*" element={<NotFound />} />  {/* Fallback route for undefined URLs */}
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default App;
